import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withBrand } from '../../../../providers/BrandProvider';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { FormBoxInput, FormField } from '../../../shared/forms';
import { renderCSSString } from '../../../../helpers';

import './VatRulesBox.scss';

const selectInput = (params) => {
  return (
    <div className="c-vat-rules__select-field">
      <FormField
        type="select"
        name={params.name}
        label={params.label}
        pattern={params.pattern}
        value={params.value}
        options={params.options}
        onChange={params.changeHandler}
        blankValue={params.blankLabel}
      />
      <i className="material-icons c-form-field__select-icon">
        keyboard_arrow_down
      </i>
    </div>
  );
};

const textInput = (params) => {
  return (
    <div className="c-vat-rules__text-field">
      <FormField
        type="text"
        name={params.name}
        pattern={{ required: params.required }}
        label={params.label}
        value={params.value}
        onChange={params.changeHandler}
      />
    </div>
  );
};

const radioGroup = (params, t) => {
  return (
    <Fragment>
      <div className="c-vat-rules__radioGroup-field error">
        <p>{params.label}</p>
        <div className="form-row row">
          {params.options.map((radioOption, optionIndex) => {
            return (
              <div className="col-xs-3" key={optionIndex}>
                <FormBoxInput
                  type="radio"
                  size="small"
                  name={params.name}
                  value={radioOption.value}
                  checked={params.value === radioOption.value}
                  label={t(
                    `site.purchase.vat-rules.vat.number.${radioOption.label}`,
                  )}
                  onChange={params.changeHandler}
                />
              </div>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

export class VatRulesBox extends Component {
  static propTypes = {
    brand: PropTypes.object,
    onVatRulesChange: PropTypes.func,
    vatFormErrors: PropTypes.object,
    vatInputs: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.vatRulesForm = React.createRef();
  }

  vatRulesDataChanged = (value, name) => {
    this.vatRulesUpdated({ fieldName: name, fieldValue: value });
  };

  vatNumberOptionChanged = (e) => {
    this.vatRulesUpdated({
      fieldName: e.target.name,
      fieldValue: e.target.value === 'true',
    });
  };

  vatRulesUpdated = (fieldData) => {
    const onVatRulesChange = this.props.onVatRulesChange;
    if (onVatRulesChange && typeof onVatRulesChange === 'function') {
      onVatRulesChange(fieldData);
    }
  };

  render() {
    const {
      brand: { secondaryColor } = {},
      t,
      vatInputs = [],
      vatFormErrors = {},
    } = this.props;

    return (
      vatInputs.length > 0 && (
        <form autoComplete="off" noValidate>
          <h4
            className="c-product-type__heading"
            style={{ color: secondaryColor }}
          >
            {t('site.purchase.vat-rules.title')}
          </h4>
          <div className="c-payment-form-block c-payment-form-block__vat-rules">
            <div className="c-payment-form-block__body">
              <div
                className={`c-vat-rules ${
                  Object.keys(vatFormErrors).length > 0 ? 'has-error' : ''
                }`}
                ref={this.vatRulesForm}
              >
                {vatInputs.map((formInput, fieldIndex) => {
                  let formField;

                  switch (formInput.type) {
                    case 'SELECT': {
                      const countryInputParams = {
                        label: t('site.purchase.person.country.label'),
                        blankLabel: t(
                          'site.purchase.vat-rules.select.countryField.blankLabel',
                        ),
                        changeHandler: this.vatRulesDataChanged,
                        pattern: { required: formInput.required },
                      };
                      const regionInputParams = {
                        label: t('site.purchase.person.province.label'),
                        blankLabel: t(
                          'site.purchase.vat-rules.select.regionField.blankLabel',
                        ),
                        changeHandler: this.vatRulesDataChanged,
                        pattern: { required: formInput.required },
                      };
                      formField = (
                        <div key={fieldIndex}>
                          {selectInput(
                            Object.assign(
                              {},
                              formInput,
                              formInput.name === 'country'
                                ? countryInputParams
                                : regionInputParams,
                            ),
                          )}
                        </div>
                      );
                      break;
                    }
                    case 'TEXT': {
                      const textInputParams = {
                        label: t('site.purchase.vat-rules.vat.number'),
                        changeHandler: this.vatRulesDataChanged,
                        pattern: { required: formInput.required },
                      };
                      formField = (
                        <div key={fieldIndex}>
                          {textInput({ ...formInput, ...textInputParams })}
                        </div>
                      );
                      break;
                    }
                    case 'CHECKBOX': {
                      const fieldLabel =
                        formInput.name === 'taxIdExemption'
                          ? 'site.purchase.vat-rules.vat.number.question'
                          : 'site.purchase.vat-rules.vat.resident.question';
                      const radioGroupParams = {
                        label: t(fieldLabel),
                        changeHandler: this.vatNumberOptionChanged,
                        pattern: { required: formInput.required },
                      };
                      formField = (
                        <div key={fieldIndex}>
                          {radioGroup({ ...formInput, ...radioGroupParams }, t)}
                        </div>
                      );
                      break;
                    }
                    default:
                      break;
                  }
                  return formField;
                })}
                {renderCSSString(`
                    .c-vat-rules .c-form-field.select,
                    .c-vat-rules .c-vat-rules__text-field input {
                      border-color: ${secondaryColor};
                    }
                `)}
              </div>
            </div>
          </div>
        </form>
      )
    );
  }
}

export default withTranslation()(connect()(withBrand(VatRulesBox)));
